import React from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend, Title);

// const generateColors = (count) => {
//   return Array.from({ length: count }, () => {
//     const randomColor = `#${Math.floor(Math.random() * 16777215).toString(16)}`;
//     return randomColor;
//   });
// };
const generateColors = (count) => {
  const mandatoryColors = ['#69C195', '#F97066', '#98A2B3', '#84BFF3', '#FDB022'];
  if (count <= mandatoryColors.length) return mandatoryColors.slice(0, count);
  return [
    ...mandatoryColors,
    ...Array.from({ length: count - mandatoryColors.length }, () => `#${Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0')}`)
  ];
};

const PieChart = ({ chartData }) => {
  const safeChartData = Array.isArray(chartData) ? chartData : [];

  const lastStats = safeChartData[safeChartData.length - 1] || {};

  const statusMap = [
    { label: "Compliant", value: lastStats.compliant || 0, color: "#69C195" },
    { label: "Non-Compliant", value: lastStats.nonCompliant || 0, color: "#F97066" },
    { label: "Invited", value: lastStats.invited || 0, color: "#0E4E9A" },
    { label: "Self-registered", value: 0, color: "#84BFF3" },
    { label: "Registered", value: lastStats.registered || 0, color: "#475467" },
    { label: "Deactivated", value: lastStats.closed || 0, color: "#FDB022" },
  ];

  const labels = statusMap.map((s) => `${s.label} ${s.value}`);
  const chartValues = statusMap.map((s) => s.value);
  const chartColors = statusMap.map((s) => s.color);

  const data = {
    labels: labels,
    datasets: [
      {
        label: "Provider Status",
        data: chartValues,
        backgroundColor: chartColors,
        hoverBackgroundColor: chartColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "right",
        labels: {
          boxWidth: 10,
          padding: 20,
          usePointStyle: true,
        },
      },
    },
    cutout: "60%",
  };

  // Custom plugin for center text
  const centerTextPlugin = {
    id: "centerText",
    beforeDraw: (chart) => {
      const {
        ctx,
        data,
        chartArea: { width, height },
      } = chart;
      ctx.save();
      const total = data.datasets[0].data.reduce(
        (acc, value) => acc + Number(value),
        0
      );

      ctx.font = "bold 20px Arial";
      ctx.fillStyle = "#1D2939";
      ctx.textAlign = "center";
      ctx.textBaseline = "middle";
      ctx.fillText(`${total}`, width / 2, height / 2 - 10);

      ctx.font = "13px Arial";
      ctx.fillText("Total Providers", width / 2, height / 2 + 10);
      ctx.restore();
    },
  };

  return (
    <div className="card-body mt-3.5">
      <Doughnut data={data} options={options} plugins={[centerTextPlugin]} />
    </div>
  );
};

export default PieChart;
